import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { skip } from "rxjs/operators";
import { LoggingService } from '../../../../../services/logging.service';
import { environment } from '../../../../../../environments/environment';
import { OtherKpFilter } from '../../../models/other-kp-filter';
import { BusOtherKpFilterService } from '../../../services/bus-other-kp-filter.service';



const apiServer = environment.apiServer;
declare var $: any;

class SearchFilter {
  search: string;
}

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}


@Component({
  selector: 'app-other-kp-main-modal-mnn',
  templateUrl: './other-kp-main-modal-mnn.component.html',
  styleUrls: ['./other-kp-main-modal-mnn.component.sass']
})
export class OtherKPMainModalMNNComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('drugCheckInput') nameInputModel: QueryList<any>;

  dt: DataTables.Api;
  modelDrugFilter: OtherKpFilter = new OtherKpFilter();
  modelOtherKPFilter: OtherKpFilter = new OtherKpFilter();
  searchFilter: SearchFilter = new SearchFilter();
  dtOptionsDrugs: DataTables.Settings = {};
  dataSetDrugs: any;
  checkedDrug: string[];

  constructor(private http: HttpClient, private bus: BusOtherKpFilterService, private loggingService: LoggingService) {
    this.checkedDrug = [];
  }

  onFieldChange() {
    const xid = this.loggingService.generateUUID();
    const qualName = `App.Components.OtherKPMainModalMNNComponent.onFieldChange`;
    const inputParams = null;
    const description = 'Изменение поля фильтра (onFieldChange)';

    this.loggingService.logStart(xid, qualName, inputParams, `${description} начато`);

    try {
      this.dt.ajax.reload();

      this.loggingService.logFinish(xid, qualName, inputParams, `${description} завершено`);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, `${description} завершено с ошибкой`);
      throw error;
    }
  }

  ngOnInit() {
    const xid = this.loggingService.generateUUID();
    const qualName = `App.Components.OtherKPMainModalMNNComponent.ngOnInit`;
    const inputParams = null;
    const description = 'Инициализация компонента (ngOnInit)';

    this.loggingService.logStart(xid, qualName, inputParams, `${description} начато`);

    try {
      this.subs.push(
        this.bus.currentClearModalFilter$
          .pipe(skip(1))  // При инициализации фильтр уже очищен
          .subscribe(key => {
            if (key === 'mnn' || key === "all") {
              this.nameInputModel.forEach(function (item) {
                item.nativeElement.checked = false;
              });
              this.checkedDrug = [];

              if (key !== "all") {
                this.onOtherKPFilter();
              }
            }
          })
      );

      const that = this;

      this.dtOptionsDrugs = {
        pagingType: 'full_numbers',
        pageLength: 50,
        serverSide: true,
        processing: true,
        autoWidth: false,
        order: [1],
        dom: 'tip',
        language: {
          emptyTable: 'Нет данных',
          info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
          infoEmpty: 'Отображено с 0 по 0 из 0 записей',
          infoFiltered: '(отфильтровано из _MAX_ записей)',
          infoPostFix: '',
          thousands: ',',
          lengthMenu: 'Показывать по _MENU_ записей',
          loadingRecords: 'Загрузка ...',
          processing: 'Обработка ...',
          search: 'Поиск:',
          zeroRecords: 'Нет совпадающих значений для поиска',
          paginate: {
            first: 'Первая',
            last: 'Последняя',
            next: 'След.',
            previous: 'Пред.'
          },
          aria: {
            sortAscending: ': activate to sort column ascending',
            sortDescending: ': activate to sort column descending'
          }
        },
        ajax: (dataTablesParameters: any, callback) => {
          dataTablesParameters.search = this.searchFilter.search;

          that.http.post<DataTablesResponse>(`${apiServer}/getGoodsShortList`, dataTablesParameters, {})
            .subscribe(resp => {
              that.dataSetDrugs = resp.data;
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            });
        },
        columnDefs: [
          {
            orderable: false,
            className: 'select-checkbox',
            targets: 0
          },
        ]
      };

      this.loggingService.logFinish(xid, qualName, inputParams, `${description} завершено`);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, `${description} завершено с ошибкой`);
      throw error;
    }
  }

  ngOnDestroy() {
    const xid = this.loggingService.generateUUID();
    const qualName = `App.Components.OtherKPMainModalMNNComponent.ngOnDestroy`;
    const inputParams = null;
    const description = 'Разрушение компонента (ngOnDestroy)';

    this.loggingService.logStart(xid, qualName, inputParams, `${description} начато`);

    try {
      this.subs.forEach(sub => sub.unsubscribe());

      this.loggingService.logFinish(xid, qualName, inputParams, `${description} завершено`);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, `${description} завершено с ошибкой`);
      throw error;
    }
  }

  onSelectedRow(event, value) {
    const xid = this.loggingService.generateUUID();
    const qualName = `App.Components.OtherKPMainModalMNNComponent.onSelectedRow`;
    const inputParams = { checked: event && event.target ? event.target.checked : null, value };
    const description = 'Выбор/снятие выбора строки';

    this.loggingService.logStart(xid, qualName, inputParams, `${description} начато`);

    try {
      if (event.target.checked) {
        this.checkedDrug.push(value);
      } else {
        for (let i = 0; i < this.checkedDrug.length; i++) {
          if (this.checkedDrug[i] === value) {
            this.checkedDrug.splice(i, 1);
          }
        }
      }

      this.loggingService.logFinish(xid, qualName, inputParams, `${description} завершено`);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, `${description} завершено с ошибкой`);
      throw error;
    }
  }

  onSelectingRows(event) {
    const xid = this.loggingService.generateUUID();
    const qualName = `App.Components.OtherKPMainModalMNNComponent.onSelectingRows`;
    const inputParams = { checked: event && event.target ? event.target.checked : null };
    const description = 'Выбор/снятие выбора всех строк';

    this.loggingService.logStart(xid, qualName, inputParams, `${description} начато`);

    try {
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedDrug.push(item.nativeElement.value);
        } else {
          for (let i = 0; i < that.checkedDrug.length; i++) {
            if (that.checkedDrug[i] === item.nativeElement.value) {
              that.checkedDrug.splice(i, 1);
            }
          }
        }
      });

      this.loggingService.logFinish(xid, qualName, inputParams, `${description} завершено`);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, `${description} завершено с ошибкой`);
      throw error;
    }
  }

  ngAfterViewInit(): void {
    const xid = this.loggingService.generateUUID();
    const qualName = `App.Components.OtherKPMainModalMNNComponent.ngAfterViewInit`;
    const inputParams = null;
    const description = 'После инициализации представлений (ngAfterViewInit)';

    this.loggingService.logStart(xid, qualName, inputParams, `${description} начато`);

    try {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        this.dt = dtInstance;
      });

      this.loggingService.logFinish(xid, qualName, inputParams, `${description} завершено`);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, `${description} завершено с ошибкой`);
      throw error;
    }
  }

  onOtherKPFilter() {
    const xid = this.loggingService.generateUUID();
    const qualName = `App.Components.OtherKPMainModalMNNComponent.onOtherKPFilter`;
    const inputParams = { selected: this.checkedDrug };
    const description = 'Применение фильтра OtherKP';

    this.loggingService.logStart(xid, qualName, inputParams, `${description} начато`);

    try {
      this.modelOtherKPFilter.mnn = this.checkedDrug.join(",");
      this.bus.changeFilter(this.modelOtherKPFilter);

      this.loggingService.logFinish(xid, qualName, inputParams, `${description} завершено`);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, `${description} завершено с ошибкой`);
      throw error;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-mnn/other-kp-main-modal-mnn.component.ts